// src/hooks/useNetworkStatus.ts
import { useState, useEffect } from 'react';

export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [connectionSpeed, setConnectionSpeed] = useState<'fast' | 'slow' | 'offline'>('fast');

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      checkSpeed();
    };
    
    const handleOffline = () => {
      setIsOnline(false);
      setConnectionSpeed('offline');
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Check speed on mount
    checkSpeed();

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const checkSpeed = async () => {
    if (!navigator.onLine) {
      setConnectionSpeed('offline');
      return;
    }

    const start = Date.now();
    try {
      await fetch('https://www.cloudflare.com/cdn-cgi/trace', { 
        method: 'HEAD',
        cache: 'no-cache' 
      });
      const duration = Date.now() - start;
      
      setConnectionSpeed(duration < 500 ? 'fast' : 'slow');
    } catch {
      setConnectionSpeed('slow');
    }
  };

  return { isOnline, connectionSpeed };
}